import { 
  Component, 
  ContentChild, 
  HostListener, 
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { TitanMenuPopoverComponent } from '../titan-menu-popover/titan-menu-popover.component';

@Component({
  selector: 'app-titan-menu-trigger',
  templateUrl: './titan-menu-trigger.component.html',
  styleUrls: ['./titan-menu-trigger.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitanMenuTriggerComponent implements AfterContentInit, OnDestroy {
  @ContentChild(TitanMenuPopoverComponent) popover?: TitanMenuPopoverComponent;

  isOpen = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {}

  ngAfterContentInit(): void {
    if (this.popover) {
      this.popover.isOpen = this.isOpen;
    }
  }

  ngOnDestroy(): void {
    this.close();
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
    if (this.popover) {
      this.popover.isOpen = this.isOpen;
    }
    this.cdr.markForCheck();
  }

  open(): void {
    if (!this.isOpen) {
      this.isOpen = true;
      if (this.popover) {
        this.popover.isOpen = this.isOpen;
      }
      this.cdr.markForCheck();
    }
  }

  close(): void {
    if (this.isOpen) {
      this.isOpen = false;
      if (this.popover) {
        this.popover.isOpen = this.isOpen;
      }
      this.cdr.markForCheck();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.close();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen) return;

    // event.target is not guaranteed to be an Element (e.g. it can be the
    // Document itself when a click is dispatched/retargeted directly onto
    // it) — a click target is always an Element or the Document, never a
    // bare Text node, so a single instanceof Element narrowing covers both
    // the contains() and closest() checks below.
    const target = event.target instanceof Element ? event.target : null;
    const host: Element = this.elementRef.nativeElement;

    if (!target || !host.contains(target) || target.closest('app-titan-menu-item')) {
      this.close();
    }
  }
}
